import LegacyMediaHandler from './LegacyHandler';
import MediaHandler from './MediaHandler';
import { DeviationTypes } from '../../types/deviation';
/**
 * The media service encapsulates all media/file access to a
 * deviation object.
 *
 * This is a gradual refactor, we are moving various functions into a
 * single interface and then replacing the function calls 1-1.
 *
 * After this we will define a stricter public interface and make the
 * others private. This should give us a clear surface to work on.
 *
 * Once that is done we can add the new handler.
 */ class DeviationMediaService {
    isGif(deviation) {
        return this.handleFileOrMedia(deviation).isGif(deviation);
    }
    isPng(deviation) {
        return this.handleFileOrMedia(deviation).isPng(deviation);
    }
    getDeviationType(deviation) {
        if (!deviation) {
            return DeviationTypes.UNKNOWN;
        }
        return this.handleFileOrMedia(deviation).getDeviationType(deviation);
    }
    getFullviewForSize(deviation, width, height) {
        return this.handleFileOrMedia(deviation).getFullviewForSize(deviation, width, height);
    }
    getSrcSetForDeviationPreview(deviation, isMobile, screenVw) {
        return this.handleFileOrMedia(deviation).getSrcSetForDeviationPreview(deviation, isMobile, screenVw);
    }
    getLargestFullview(deviation) {
        return this.handleFileOrMedia(deviation).getLargestFullview(deviation);
    }
    getThumbDimensions(deviation) {
        return this.handleFileOrMedia(deviation).getThumbDimensions(deviation);
    }
    getSmallestThumb(deviation) {
        return this.handleFileOrMedia(deviation).getSmallestThumb(deviation);
    }
    getSmallestThumbThatFullyCovers(deviation, width, height, fallback, options) {
        return this.handleFileOrMedia(deviation).getSmallestThumbThatFullyCovers(deviation, width, height, fallback, options);
    }
    /**
   * TODO make this private
   *
   * @param deviation
   * @param fileType
   */ getDeviationFile(deviation, fileType) {
        return this.handleFileOrMedia(deviation).getDeviationFile(deviation, fileType);
    }
    /**
   * Get default set of thumbs from the deviation
   */ getThumbSet(deviation, options) {
        return this.handleFileOrMedia(deviation).getThumbSet(deviation, options);
    }
    getMediaByType(deviation, fileType) {
        return this.handleFileOrMedia(deviation).getMediaByType(deviation, fileType);
    }
    handleFileOrMedia(deviation) {
        if (deviation && deviation.media) {
            return new MediaHandler();
        }
        return new LegacyMediaHandler();
    }
    getSmallestThumbForArtStage(deviation, width, height) {
        return this.handleFileOrMedia(deviation).getSmallestThumbForArtStage(deviation, width, height);
    }
}
export default new DeviationMediaService();

//# sourceMappingURL=DeviationMediaService.js.map